import React from "react";
import "./Footer.css";

export default () => (
  <div className="Footer">
    Code en data beschikbaar op{" "}
    <a href="https://github.com/larixk/coalitiemaker.nl/">GitHub</a>. Pull
    requests zijn welkom.
    <br />
    Door <a href="http://larixk.nl/">Larix Kortbeek</a> en Jurian van der Hoeven
  </div>
);
